import React, { useMemo } from "react";

import ChevronLeftRoundedIcon from "@mui/icons-material/ChevronLeftRounded";
import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";
import { useTranslation } from "react-i18next";
import ReactPaginate from "react-paginate";

import { usePermissions } from "hooks/permission";

import { CardLeftItem } from "components/CardLeftItem";
import PageHeader from "components/PageHeader";
import SearchEmpty from "components/SearchEmpty";

import { FORMS_HEARING } from "utils/entities/permission";

import { IListProcedures } from "./interface";
import { LeftListSkeleton } from "./LeftListSkeleton";
import { Container, Content, Pagination } from "./styles";
import { areEqual, status } from "./util";

const LeftListComponent: React.FC<IListProcedures> = ({
  principalLabel,
  onClick,
  audienceSelected,
  addClick,
  backgroundHeader = "primary",
  audiences,
  totalCount,
  currentPage = 0,
  pageCount = 0,
  onPageChange,
  filterClick,
  disabledFilter,
  isFilter,
  isLoading = false,
  isInqueritoProduct = false,
}) => {
  const { t } = useTranslation();
  const { read, create } = usePermissions(FORMS_HEARING.HEARING);
  const list = useMemo(
    () => (Array.isArray(audiences) ? audiences : []),
    [audiences],
  );

  return (
    <Container>
      <PageHeader
        id="header"
        label={principalLabel}
        background={backgroundHeader}
        addClick={create ? addClick : undefined}
        filterClick={read ? filterClick : undefined}
        deleteClick={() => {}}
        disabledDeleteButton
        disabledFilterButton={disabledFilter}
        isFilter={isFilter}
        quantity={totalCount ?? list.length}
      />
      {read ? (
        <>
        <Content id="audience_container">
          {isLoading ? (
            <LeftListSkeleton cardCount={list.length || 5} />
          ) : list.length > 0 ? (
            list.map((a) => {
              return (
                <CardLeftItem
                  id={`audience_card_${a.id}`}
                  key={a.id}
                  date={new Date(a.expectedDate)}
                  labelStatus={status(a.status).status}
                  userName={a.extraContent}
                  title={String(a.procedureNumber)}
                  subTitle={a.hearingTypeName || "não informado"}
                  type={status(a.status).type}
                  selected={a.id === audienceSelected?.id}
                  onClick={() => onClick(a)}
                  showOnlyDate={isInqueritoProduct}
                />
              );
            })
          ) : (
            <SearchEmpty
              textMessage={t("audiences.none")}
              typeIcon="file"
              marginTop="40px"
            />
          )}
        </Content>
        {pageCount > 1 && onPageChange && (
          <Pagination>
            <ReactPaginate
              previousLabel={<ChevronLeftRoundedIcon fontSize="small" />}
              nextLabel={<ChevronRightRoundedIcon fontSize="small" />}
              pageCount={pageCount}
              forcePage={currentPage}
              onPageChange={({ selected }) => onPageChange(selected)}
              pageRangeDisplayed={1}
              marginPagesDisplayed={1}
              containerClassName="pagination"
              activeClassName="active"
              disabledClassName="disabled"
            />
          </Pagination>
        )}
        </>
      ) : (
        <SearchEmpty
          textMessage={t("common.noPermissionForProfile")}
          typeIcon="avatar"
          marginTop="40px"
        />
      )}
    </Container>
  );
};

export const LeftList = React.memo(LeftListComponent, areEqual);
